<template>
  <div>
    <!-- 条款 -->
    <div class="b_box" v-show="showType">
      <div class="agreement_box dis_f ali_ct fle_t">
        <img @click="closeShow" src="@/assets/img/agreement_close.png" class="close_btn" alt>
        <div class="fl1 w100 agreement_count">
          <div class="w100 h100" style="overflow: auto;">
            <img v-show="showEn" src="@/assets/img/agreement_txt_en.png" class="w100" alt>
            <img v-show="!showEn" src="@/assets/img/agreement_txt.png" class="w100" alt>
          </div>
        </div>
        <!-- <div class="agreement_title">活动条款及细则</div> -->
        <!-- <div class="fl1"></div> -->
        <img
          @click="closeShow"
          v-if="showEn"
          src="@/assets/img/agreement_btn_en.png"
          class="agreement_btn fle_no"
        >
        <img
          @click="closeShow"
          v-else
          src="@/assets/img/agreement_btn.png"
          class="agreement_btn fle_no"
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  model: {
    prop: "showType",
    event: "changetype"
  },
  props: {
    showType: {
      type: Boolean,
      default: false
    },
    showEn: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    closeShow() {
      this.$emit("changetype", false);
    }
  }
};
</script>

<style lang="scss" scoped>
.b_box {
  padding: 60px;
  .agreement_box {
    background-color: #ffffff;
    box-shadow: 5px 5px 6px 0px rgba(0, 0, 0, 0.16);
    border: solid 5px #f00000;
    height: 100%;
    padding-top: 70px;
    position: relative;
    padding: 80px 48px 0;
    .close_btn {
      width: 51px;
      position: absolute;
      top: 28px;
      right: 24px;
    }
    .agreement_title {
      color: #0d0000;
      font-size: 40px;
      padding-top: 67px;
      padding-bottom: 30px;
      font-weight: bold;
    }
    .agreement_count {
      overflow: auto;
    }
    .agreement_btn {
      width: 329px;
      padding-bottom: 38px;
      padding-top: 60px;
    }
  }
}
</style>
